module.exports = __webpack_public_path__ + "images/map_marker.ede17e94939d075a7a0222a327f21a69.png";